import { Nullable, Optional } from 'frontcore/presentation/types'

export type PerimeterAPIResponse = {
  id: number
  created: string
  description: string
  device_update: string
  name: string
  media: number | null
  parent: number | null
  pattern: number
  updated: string
  external_id?: string | null
  factory_url?: string | null
}

export class Perimeter {
  id: number
  description: string
  name: string
  media: number | null
  parent: number | null
  pattern: number
  userHasPermission?: boolean
  externalId?: string | null
  factoryURL?: string | null

  constructor (
    {id, description, name, media, parent, pattern, userHasPermission, externalId, factoryURL}:
    {
      id: number
      description: string
      name: string
      media: number | null
      parent: number | null
      pattern: number
      userHasPermission?: boolean
      externalId?: string | null
      factoryURL?: string | null
    }
  ) {
    this.id = id
    this.description = description
    this.name = name
    this.media = media
    this.parent = parent
    this.pattern = pattern
    this.userHasPermission = userHasPermission
    this.externalId = externalId
    this.factoryURL = factoryURL  
  }
}

export type PatternAPIResponse = {
  id: number
  localized: Record<string, string>
  callers: string[]
  allowance: boolean
  parent: number | null
}

export interface Pattern {
  id: number
  localized: Record<string, string>
  callers: string[]
  allowance: boolean
  parent: number | null
}

export interface FactoryLevel extends Pattern {
  perimeters: number[]
  selectedPerimeter: number | null
}

export type PerimeterFinderViewModel = {
  levelsNumber: number
  factoryLevels: PerimeterFactoryLevel[]
  isFinderOpen: boolean
  selectedPerimeterPath: string[]
  isOverallManager: boolean
  hasPermissionOnLastSelectedPerimeterId: boolean
  patternFromCaller: Optional<Pattern>
}

export interface IPerimeterFinderUseCase {
  cleanSelection: (factoryLevelValues: FactoryLevelWithSelectedPerimeter[], factoryLevelId: number) => FactoryLevelWithSelectedPerimeter[]
  getPerimeterById: (perimeterId: Nullable<number>) => Optional<Perimeter>
  getPerimeterParentsById: (perimeterId: Nullable<number>) => Perimeter[]
  loadFactoryLevels: () => Promise<void>
  setIsPerimeterFinderOpen: (state: boolean) => void
  selectPerimeterIds: (ids: PerimeterFactoryLevel['id'][]) => void
  getFactoryLevelName: (factoryLevel: PerimeterFactoryLevel) => string
  viewmodel: PerimeterFinderViewModel
}

export interface PerimeterFactoryLevel {
  id: number
  callers: string[]
  filteredPerimeters: Perimeter[]
  name: string
  parent: PerimeterFactoryLevel | null
  perimeters: Perimeter[]
  type?: number
}

export interface FactoryLevelWithSelectedPerimeter {
  factoryLevelId: number
  perimeterSelectedId: Nullable<number>
}

export interface PerimeterAPIClient {
    request: () => Promise<PerimeterAPIResponse[]>
    retrieve: (id: number) => Promise<PerimeterAPIResponse>
}
